import React from 'react'
import cn from 'classnames';

import styles from './GradientText.module.scss';

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
  textClassName?: string;
}

export function GradientText({ children, className, textClassName }: GradientTextProps): JSX.Element{
  return (
    <div className={cn(styles.gradientContainer, className)}>
      <span className={cn(styles.gradient, textClassName)}>
        {children}
      </span>
    </div >
  )
}